<div class="app-ActionBar-content">
  <ng-content select="app-action-bar-left-content"></ng-content>
  <ng-content select="app-action-bar-center-content"></ng-content>
  <ng-content select="app-action-bar-right-content"></ng-content>
</div>
